import clsx from 'clsx';

/**
 * Avatar — entity marker with initials or icon/image.
 *
 * Props:
 *   accent - color theme (same keys as IconTile)
 *   shape  - "circle" (default) | "square"
 *   size   - 24 | 28 (default) | 32 | 36 | 40 | 44
 */
const ACCENTS = {
  green:  'bg-emerald-50 text-emerald-700',
  amber:  'bg-amber-50 text-amber-700',
  blue:   'bg-blue-50 text-blue-700',
  pink:   'bg-pink-50 text-pink-700',
  purple: 'bg-fuchsia-50 text-fuchsia-700',
  indigo: 'bg-indigo-50 text-indigo-700',
  teal:   'bg-teal-50 text-teal-700',
  red:    'bg-red-50 text-red-700',
  none:   'bg-inset text-ink',
};

const SIZES = {
  24: 'w-6 h-6 text-[10px]',
  28: 'w-7 h-7 text-xs',
  32: 'w-8 h-8 text-xs',
  36: 'w-9 h-9 text-13',
  40: 'w-10 h-10 text-sm',
  44: 'w-11 h-11 text-base',
};

export function Avatar({ children, accent = 'none', size = 28, shape = 'circle', className = '' }) {
  return (
    <span className={clsx(
      'inline-flex items-center justify-center shrink-0 font-bold font-sans overflow-hidden',
      shape === 'circle' ? 'rounded-full' : 'rounded-md',
      ACCENTS[accent] || ACCENTS.none,
      SIZES[size] || SIZES[28],
      className,
    )}>
      {children}
    </span>
  );
}
